import { c as _c } from "react/compiler-runtime";
import { CompanyMemberRole } from "@components/table/members/members-column/role-column/company-member-role";
import { GroupMemberRole } from "@components/table/members/members-column/role-column/group-member-role";
import { ProjectMemberRole } from "@components/table/members/members-column/role-column/project-member-role";
import { Text } from "@flat-ui";
import { formatUserRoleType } from "@utils/data-display";
/** Content to show for role member column */
export function RoleColumn(t0) {
  const $ = _c(21);
  const {
    companyId,
    selectedProject,
    subjectType,
    memberIdentityRole,
    group,
    isReadOnly: t1,
    subjectName,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  if (subjectType === "project" && selectedProject) {
    let t2;
    if ($[0] !== companyId || $[1] !== isReadOnly || $[2] !== member || $[3] !== memberIdentityRole || $[4] !== selectedProject) {
      t2 = <ProjectMemberRole companyId={companyId} project={selectedProject} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} location="role-column" member={member} />;
      $[0] = companyId;
      $[1] = isReadOnly;
      $[2] = member;
      $[3] = memberIdentityRole;
      $[4] = selectedProject;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (subjectType === "workspace" || subjectType === "team") {
    const t2 = subjectType === "team" ? subjectName : undefined;
    const t3 = subjectType === "workspace" ? member : undefined;
    let t4;
    if ($[6] !== companyId || $[7] !== isReadOnly || $[8] !== memberIdentityRole || $[9] !== t2 || $[10] !== t3) {
      t4 = <CompanyMemberRole companyId={companyId} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} variant="borderless" location="role-column" teamName={t2} member={t3} />;
      $[6] = companyId;
      $[7] = isReadOnly;
      $[8] = memberIdentityRole;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (subjectType === "group" && group) {
    let t2;
    if ($[12] !== companyId || $[13] !== group || $[14] !== isReadOnly || $[15] !== memberIdentityRole) {
      t2 = <GroupMemberRole companyId={companyId} selectedGroup={group} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} location="role-column" />;
      $[12] = companyId;
      $[13] = group;
      $[14] = isReadOnly;
      $[15] = memberIdentityRole;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    return t2;
  }
  if (subjectType === "activeMembers") {
    let t2;
    if ($[17] !== memberIdentityRole.role) {
      t2 = formatUserRoleType(memberIdentityRole.role);
      $[17] = memberIdentityRole.role;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    let t3;
    if ($[19] !== t2) {
      t3 = <Text variant="bodyS">{t2}</Text>;
      $[19] = t2;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    return t3;
  }
  return null;
}